/** App.css --wlg-neis-short-edge color-mix 대체( html2canvas 호환 ) */
export const NEIS_SHORT_EDGE_HEX = {
  light: '#28712d',
  dark: '#4c9451',
} as const;

export function resolveNeisShortEdgeColor(): string {
  return document.documentElement.getAttribute('data-theme') === 'light'
    ? NEIS_SHORT_EDGE_HEX.light
    : NEIS_SHORT_EDGE_HEX.dark;
}
